import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Use toast
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'full_name', label: 'Full name', sortable: true },
    { key: 'mob_phone_no', label: 'Mobile phone', sortable: true },
    { key: 'role_id', label: 'Role', sortable: true },
    { key: 'org_id', label: 'Organization', sortable: true },
    { key: 'user_type', label: 'User Type', sortable: true },
    { key: 'pin', sortable: true, label: 'Pin' },
    { key: 'email', sortable: true, label: 'Email' },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('user'),
  }
}
